export const ROLE_LIST_ATTRIBUTES_CONSTANT = {
  roleType: {
    type: 'text',
    key: 'role_type',
    label: 'Role Type',
  },
} as const;
